// extracted by mini-css-extract-plugin
export default {"blocks-container":"blocks-container_t6lkzdB8","button-container":"button-container_PdJqDAEO"};